<div [class.full-length]="isFullLength" [class.light]="lightColor" class="{{ inclination }}"></div>
